import { Pagination } from "../../../../model/pagination";
import HttpClient from "../../../services/http-client";
import { serialize } from "object-to-formdata";
import { IIrpPageRequest } from "../../../../model/scp/irp/request/irp-paged-request";
import { IIrpPagedResponse } from "../../../../model/scp/irp/response/irp-paged-response";
import { IIrpAddEditRequest } from "../../../../model/scp/irp/request/irp-add-edit-request";
import { IIrpItemAddEditRequest } from "../../../../model/scp/irp/request/irp-item-add-edit-request";
import { IIrpResponse } from "../../../../model/scp/irp/response/irp-response";
import { IIrpItemPageRequest } from "../../../../model/scp/irp/request/irp-item-paged-request";
import { IIrpItemResponse } from "../../../../model/scp/irp/response/irp-item-response";
import { IFilePageRequest } from "../../../../model/scp/base/request/file-paged-request";
import { IFileResponse } from "../../../../model/scp/base/response/file-response";
import { IFileAddRequest } from "../../../../model/scp/base/request/file-add-request";

const defaultPath = 'Irp';

const listIrp = async (params: IIrpPageRequest): Promise<Pagination<IIrpPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: params
    }).then((response) => Object.assign(new Pagination<IIrpPagedResponse>(), response.data));
};

const listAllIrp = async (): Promise<IIrpPagedResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/All`,
    }).then((response) => Object.assign([] as unknown as IIrpPagedResponse, response.data));
};

// Itens e documentos da IRP não são espelhados localmente: a API consulta o PNCP
// ao vivo a cada chamada e retorna um array simples, sem metadados de total.
const listIrpItems = async (params: IIrpItemPageRequest): Promise<IIrpItemResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${params.id}/Items`,
        params: { page: params.page, pageSize: params.pageSize }
    }).then((response) => Object.assign([] as unknown as IIrpItemResponse[], response.data));
};

const listIrpFiles = async (params: IFilePageRequest): Promise<IFileResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${params.id}/Files`,
        params: { page: params.page, pageSize: params.pageSize }
    }).then((response) => Object.assign([] as unknown as IFileResponse[], response.data));
};

const addItemsIrp = async (id: number, params: IIrpItemAddEditRequest[]) => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${id}/Items`,
        data: { items: params }
    });
};

const updateItemsIrp = async (id: number, params: IIrpItemAddEditRequest[], justification: string) => {
    return await HttpClient.executeRequest({
        method: 'patch',
        url: `/${defaultPath}/${id}/Items`,
        data: { items: params, justification }
    });
};

const deleteItemsIrp = async (id: number, itemNumbers: number[], justification: string) => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}/Items`,
        data: { itemNumbers, justification }
    });
};

const getIrp = async (id: number): Promise<IIrpResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`,
    }).then((response) => Object.assign({} as IIrpResponse, response.data));
};

const deleteIrp = async (justification: string, id: number) => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`,
        params: { justification }
    });
}

const updateIrp = async (id: number, params: IIrpAddEditRequest) => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params,
    });
}

const addIrp = async (params: IIrpAddEditRequest, file: File, items: string) => {
    const formData = serialize({ ...params, items }, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    formData.append("document", file);

    // A API devolve o registro criado; o id leva o usuário à edição para anexar documentos
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then((response) => Object.assign({} as IIrpResponse, response.data));
};

const addFileIrp = async (params: IFileAddRequest) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${params.id}/Files`,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const deleteFileIrp = async (justification: string, id: number, number: number) => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}/Files/${number}`,
        params: { justification }
    });
}

const IrpAppService = {
    listIrp, addIrp, deleteIrp, getIrp, listAllIrp, updateIrp, listIrpItems, addItemsIrp, updateItemsIrp, deleteItemsIrp, listIrpFiles, addFileIrp, deleteFileIrp
};

export default IrpAppService;
